import { Form, Select } from 'antd';
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint';
import * as Api from 'api';
import { useEffect, useState } from 'react';
import useAuth from 'redux/auth/auth.hook';
import classes from './style.module.scss';

const { Option, OptGroup } = Select;

const FilterTargetProfile = (props) => {
  const [form] = Form.useForm();
  const { auth: { profile } } = useAuth();
  const { md } = useBreakpoint();
  const [categoryArr, setCategoryArr] = useState([]);
  const [filterOptions, setFilterOption] = useState({
    category: 'all',
    tag: '',
    count_type: 1,
    camera_id: 0,
  });

  const [tagArr, setTagArr] = useState<any[]>([]);

  useEffect(() => {
    if (profile) {
      // get cameras and tags
      Api.CAMERAS_GROUPS_TAGS().then((res: any) => {
        const data = JSON.parse(res.text);
        try {
          setTagArr(data.tags);
          const newFilter = { ...filterOptions, camera_id: 0 };
          setFilterOption(newFilter);
          props.handleFilters(newFilter);
          form.setFieldsValue(newFilter);
        } catch (e) {
          // console.log(e.message);
        }
      });
      http_load_categories();
    }
  }, [profile]);

  const http_load_categories = () => {
    Api.DETECTION_THRESHOLD().then(((res: any) => {
      const data = JSON.parse(res.text);
      const tcategories = data.filter((item) => item.enable == '1');
      const cates = tcategories.map((item) => (
        { value: item.category.toLowerCase(), name: item.category }
      ));
      cates.unshift({ value: 'all', name: 'All' });
      setCategoryArr(cates);
    })).catch((error: any) => {
      console.log('error ===>', error);
    });
  };

  const onValuesChange = (values, allvalues) => {
    const newFilter = { ...filterOptions, ...allvalues };
    setFilterOption(newFilter);
    props.handleFilters(newFilter);
  };

  return (
    <div className={classes.wrapper}>
      <Form form={form} style={{ marginTop: md ? 20 : 0 }} onValuesChange={onValuesChange}>
        <div className={classes.formInputLabel}>Choose Tag:</div>
        <Form.Item name="tag" className={classes.formInputWrapper}>
          <Select size="large">
            <Option key={0} value="">All</Option> :
            {tagArr.map((val: any) => (
              val.tag != '' && (<Option key={val.tag} value={val.tag}>{val.tag}</Option>)
            ))}
          </Select>
        </Form.Item>
        <div className={classes.formInputLabel}>Choose Category:</div>
        <Form.Item name="category" className={classes.formInputWrapper}>
          <Select size="large">
            {categoryArr.map((val: any) => (
              <Option key={val.value} value={val.value}>{val.name}</Option>
            ))}
          </Select>
        </Form.Item>
      </Form>
    </div>
  );
};

export default FilterTargetProfile;
